module.exports = __webpack_public_path__ + "static/footer-graphic-2afa6a3ecc2704cdd0be676f5f3ed385.svg";